module.exports = __webpack_public_path__ + "static/restock-43726293fb5c8e79ec8843dafc5983d8.mp4";